import type { Panel, IndicatorData, LabeledListData, ChatConfig } from '@/types/dashboard';
import type { EntityListData } from '@/types/entity-list';
import type { IndicatorConfig } from '@/types/indicators';
import type { LabeledListConfig } from '@/types/labeled-list';
import type { ChartConfig, ChartBackendData } from '@/types/chart';
import { IndicatorWidget } from '@/widgets/IndicatorWidget';
import { LabeledListWidget } from '@/widgets/LabeledListWidget';
import { ChartWidget } from '@/widgets/ChartWidget';
import { ChatWidget } from '@/widgets/ChatWidget';
import { EntityListWidget } from '@/widgets/EntityListWidget';
import { ErrorBoundary } from './common/ErrorBoundary';
import { t } from '@/i18n';

function WidgetContent({ panel }: { panel: Panel }) {
  switch (panel.type) {
    case 'indicator':
      return <IndicatorWidget config={panel.config as unknown as IndicatorConfig} data={panel.data as IndicatorData | undefined} />;
    case 'labeled_list':
      return <LabeledListWidget config={panel.config as unknown as LabeledListConfig} data={panel.data as LabeledListData | undefined} />;
    case 'chart':
      return <ChartWidget config={panel.config as unknown as ChartConfig} data={panel.data as ChartBackendData | undefined} />;
    case 'chat':
      return <ChatWidget config={panel.config as unknown as ChatConfig} contextKey={panel.contextKey || ''} currentUser={panel.currentUser} />;
    case 'entity_list':
      return <EntityListWidget config={panel.config as unknown as Record<string, unknown>} data={panel.data as EntityListData | undefined} panelWidth={panel.w} />;
    default:
      return <div className="text-muted text-center p-3">{t('dashboard.unknownWidget')}: {panel.type}</div>;
  }
}

export function WidgetRenderer({ panel }: { panel: Panel }) {
  return (
    <ErrorBoundary resetKeys={[panel.data]}>
      <WidgetContent panel={panel} />
    </ErrorBoundary>
  );
}
